import { Component } from '@angular/core';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.scss'],
  standalone: true,
  imports: [LoadingBarModule,
    TranslateModule,
  ],
})
export class PageLoaderComponent {
  constructor() {
    //constructor
  }
}
